"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSpursOptionChange = void 0;
function handleSpursOptionChange(changedOptions, setOptions, bridge, particleSize, size, spursManager) {
    setOptions(prev => {
        const newOptions = Object.assign(Object.assign({}, prev), changedOptions);
        if (changedOptions.type !== undefined) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateSpurs({ type: changedOptions.type });
            bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
                type: newOptions.type,
                currentOptions: {
                    type: newOptions.type,
                    sizeIndex: newOptions.size,
                    size: newOptions.particleSize,
                },
            });
            spursManager === null || spursManager === void 0 ? void 0 : spursManager.updateSpursOptions({
                type: newOptions.type,
                size: newOptions.size,
                particleSize: newOptions.particleSize,
            });
        }
        if (changedOptions.size !== undefined) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                type: newOptions.type,
                optionType: 1,
                size: changedOptions.size,
            });
            spursManager === null || spursManager === void 0 ? void 0 : spursManager.updateSpursOptions({
                type: newOptions.type,
                size: changedOptions.size,
                particleSize: particleSize,
            });
        }
        if (changedOptions.particleSize !== undefined) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
                type: newOptions.type,
                optionType: 2,
                val: changedOptions.particleSize,
            });
            spursManager === null || spursManager === void 0 ? void 0 : spursManager.updateSpursOptions({
                type: newOptions.type,
                size: size,
                particleSize: changedOptions.particleSize,
            });
        }
        return newOptions;
    });
}
exports.handleSpursOptionChange = handleSpursOptionChange;
